import { isEmpty, not } from 'ramda';
import type { PropsWithChildren } from 'react';
import React from 'react';

import { FeaturePicker } from '@/features/build-calculation-context/components/Home/components/ArcGisMapContainer/FeaturePicker/FeaturePicker';
import {
  displayFeatureDetailsBy,
  useWebMap
} from '@/features/execute-calculation-set/components/Calculation/GridElementsCalculationTacticResults/useFeatureDetails';
import { useActions } from '@/overmind';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import { useMapView } from './MapViewProvider';

export const EsriFeaturePicker: React.FunctionComponent<
  PropsWithChildren<{
    features: any[];
    graphics: any[];
    mapInteractionLocation: { x: number; y: number };
  }>
> = props => {
  const view = useMapView();
  console.log({ view });
  const webmap = useWebMap();
  const { setSelectedFeature } = useActions().selectedFeature;
  const featuresToPickFrom = props.features as any;
  const anyFeaturesToPickFrom = not(isEmpty(featuresToPickFrom));
  const [isPickingFeatures, setIsPickingFeatures] = React.useState(
    anyFeaturesToPickFrom
  );

  React.useEffect(() => {
    setIsPickingFeatures(anyFeaturesToPickFrom);
  }, [anyFeaturesToPickFrom, featuresToPickFrom]);

  if (webmap.type !== 'READY') return null;

  const selectFeature = (selected: FeatureWithIDs) => {
    setIsPickingFeatures(false);
    setSelectedFeature({ ...selected });
    const selectedFeatureIndex = props.features.findIndex(
      g => g.gc.globalId === selected.gc.globalId
    );
    const selectedFeatureGraphic = props.graphics[selectedFeatureIndex];
    // TODO: Should it be here? What does it cause? We already display feature details by using `useFeatureDetails` hook
    // displayFeatureDetailsBy(webmap.webMap, webmap.webMap.basemap.baseLayers.at(0).spatialReference, selectedFeatureGraphic, {
    //   withCleanup: true
    // });
  };

  return (
    <>
      {isPickingFeatures ? (
        <>
          <FeaturePicker
            featuresToPickFrom={{
              features: featuresToPickFrom,
              mapInteractionLocation: props.mapInteractionLocation
            }}
            onSelected={selectFeature}
            onClose={() => {}}
          />
        </>
      ) : null}
    </>
  );
};
